import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Actions, Selectors } from '@grandvisionhq/auth';
import { ScrollIntoView, Button } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Password, Util, PasswordWithStrengthIndicator, isPasswordBelowStrengthLevel } from '@grandvisionhq/forms';
import { Alert } from '@grandvisionhq/iris-ui';
import { connect, withIntl, statusFailed, statusIdle, statusLoading } from '@grandvisionhq/state';

const setInitialState = (name)=>({
        value: '',
        name,
        isValid: false
    })
;
const isPasswordStrongEnough = (value)=>!isPasswordBelowStrengthLevel(value, 'strong')
;
const getErrorLabel = ({ auth , getLabel , hasPasswordError , currentPassword , newPassword  })=>{
    if (auth.changePasswordCall.error) {
        var ref, ref1;
        // In case of any auth0 custom errors
        if (((ref = auth.changePasswordCall.error) === null || ref === void 0 ? void 0 : (ref1 = ref.customData) === null || ref1 === void 0 ? void 0 : ref1.auth0ErrorCode) === 'wrong_email_or_password') {
            return getLabel('account.changePassword.current.error');
        }
        return getLabel('account.changePassword.errors.general');
    }
    if (!currentPassword || !newPassword) {
        // The password fields cannot be empty
        return getLabel('fields.input.password.errorMessage');
    } else if (hasPasswordError && !isPasswordStrongEnough(newPassword)) {
        return getLabel('account.passwordStrength.notStrongEnough');
    }
};
class ChangePassword extends React.Component {
    render() {
        const { getLabel  } = this.props.intl;
        const _props = this.props, { auth , className  } = _props, rest = swcHelpers.objectWithoutProperties(_props, [
            "auth",
            "className"
        ]);
        const { hasPasswordError  } = this.state;
        const hasError = statusFailed(auth.changePasswordCall) || hasPasswordError;
        const errorLabel = getErrorLabel({
            auth,
            getLabel,
            hasPasswordError,
            currentPassword: this.state.currentPassword.value,
            newPassword: this.state.newPassword.value
        });
        const isCurrentPasswordCorrect = (value)=>{
            var ref, ref2;
            return !!(value && ((ref = auth.changePasswordCall.error) === null || ref === void 0 ? void 0 : (ref2 = ref.customData) === null || ref2 === void 0 ? void 0 : ref2.auth0ErrorCode) !== 'wrong_email_or_password');
        };
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("form", {
            className: classnames('change-password', className),
            "data-t": rest['data-t'],
            noValidate: true,
            onSubmit: this.handleSubmit
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "smallest",
            component: "h2"
        }, getLabel('account.changePassword')), hasError && /*#__PURE__*/ React.createElement(ScrollIntoView, null, /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            className: "alert-m-default"
        }, errorLabel)), this.props.isSuccess && statusIdle(auth.changePasswordCall) && /*#__PURE__*/ React.createElement(ScrollIntoView, null, /*#__PURE__*/ React.createElement(Alert, {
            variant: "success",
            className: "alert-m-default"
        }, getLabel('account.changePassword.success'))), /*#__PURE__*/ React.createElement(Password, {
            "data-t": "current-password",
            label: getLabel('account.currentPassword'),
            onChange: (value)=>this.setState({
                    currentPassword: value
                })
            ,
            validations: [
                isCurrentPasswordCorrect,
                Util.validations.isRequired
            ],
            errorMessage: errorLabel
        }), /*#__PURE__*/ React.createElement(PasswordWithStrengthIndicator, {
            "data-t": "new-password",
            hasError: hasPasswordError,
            label: getLabel('account.newPassword'),
            value: this.state.newPassword.value,
            onChange: (value)=>this.setState({
                    newPassword: value
                })
        }), /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('account.action.changePassword'),
            isLoading: statusLoading(auth.changePasswordCall) || this.state.isRedirecting,
            "data-t": "submit",
            type: "submit",
            className: "change-password__button"
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            currentPassword: setInitialState('currentPassword'),
            newPassword: setInitialState('newPassword'),
            isRedirecting: false,
            hasPasswordError: false
        };
        this.handleSubmit = (event)=>{
            event.preventDefault();
            const { auth  } = this.props;
            const { currentPassword , newPassword  } = this.state;
            if (auth.email && newPassword.isValid) {
                this.setState({
                    hasPasswordError: false
                });
                this.props.changePassword({
                    email: auth.email,
                    currentPassword: currentPassword.value,
                    newPassword: newPassword.value
                });
            }
            if (!currentPassword.isValid || !newPassword.isValid) {
                this.setState({
                    hasPasswordError: true
                });
            }
        };
    }
}
const mapStateToProps = (state)=>({
        auth: Selectors.getAuth(state)
    })
;
const mapDispatchToProps = {
    changePassword: Actions.ResetPasswordActions.changePassword
};
var ChangePassword$1 = connect(mapStateToProps, mapDispatchToProps)(withIntl(ChangePassword));

export { ChangePassword, ChangePassword$1 as default, mapDispatchToProps, mapStateToProps };
//# sourceMappingURL=ChangePassword.js.map
